import type { FaireProductEntity } from "../../entity_types/product";

export const p_puv5fb6gs4: FaireProductEntity = {
  token: "p_puv5fb6gs4",
  type: "product",
  name: 'Monarch Kaleidoscope 2" X 3" Magnet',
  brandToken: "b_ihxgqwki5y",
  brandName: "Atlas Screen Printing",
  imageUrl:
    "https://cdn.faire.com/fastly/5a32d54ed590906bc4152d87004ab33d6ac3ec9840aac60d237a2acf32f48c34.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.42,
  description:
    'WILD COTTON® 2" X 3" Wrapped Magnet. Decorated with our original art makes this a unique gift. This durable magnet will look good any place you put it and will last a long time.',
  tags: [],
  msrpDollars: 4.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:07.414Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
